import BaseApiService from './base.service';

export default class BaseConquestApiService extends BaseApiService {
    constructor() {
        super(window._env_.GATEWAY_API_URL);
    }
}
